import React from "react";
import { Container } from "@material-ui/core";
import SignUpServiceCallListWithData from "./signup/SignUpServiceCallList";

export default class AdminPanel extends React.Component {
  render() {
    return (
      <Container>
        <SignUpServiceCallListWithData />
      </Container>
    );
  }
}
